import React from 'react';
import '../ProductsTable/index.scss';
import { Link } from 'react-router-dom';
import { FaCheck, FaQuestion } from 'react-icons/fa';

export default function SignatureTable({
	plansYalo,
	loja,
}) {

	const assinaturas = [
		{titulo:"YALO Família" , styleTop:"table-vida"},
		{titulo:"YALO Fidelidade" , styleTop:"table-fidelidade"},
		{titulo:"YALO Saúde" , styleTop:"table-saude"}
	]

	const tablePrice = [{
		price:"24,90" ,
		styleButton:{
			background: '#E7E70D',
			border: '1px solid #E7E70D',
			color: '#16477D'
		},
		styleBot:"table-vida bottom",
		link:"/loja/familia/beneficiario?assinatura=familia&code=94"
	},{
		price:"31,00" ,
		styleButton:{
			background: '#e3672d',
			border: '1px solid #E7E70D',
			color: '#16477D'
		},
		styleBot:"table-fidelidade bottom",
		link:"/loja/yalo/beneficiario?assinatura=fidelidade&code=18"
	},{
		price:"53,20" ,
		styleButton:{
			background: '#E7E70D',
			border: '1px solid #E7E70D',
			color: '#16477D'
		},
		styleBot:"table-saude bottom",
		link:"/loja/yalo/beneficiario?assinatura=saude&code=9"
	},]

	var size = Object.keys(plansYalo).length;
	const colCount =
		size === 1 ? 'unique-col' : size === 2 ? 'double-col' : 'col-grid';

	return (
		<section className='section-table'>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col-12'>
						<h2 style={{ color: '#0079b3', padding: '0 5px' }}>
							{loja === 'fretebras' ||
							loja === 'brasiladmindividual' ||
							loja === 'emed' ||
							loja === 'brasiladmvida' ||
							loja === 'brasiladmfidelidade' ? (
								<strong>Conheça nossa assinatura</strong>
							) : (
								<strong>Conheça nossas assinaturas</strong>
							)}
						</h2>
						<div className={`set-table ${colCount}`}>
							<table className='table-wrapper'>
								<tbody>
									<tr className={loja}>
									<th className='noneOnMobile'></th>
										{assinaturas.map((assinatura)=>{
											return(
										<th className={assinatura.styleTop}>
											{assinatura.titulo}
											</th>
										)})}
										</tr>
									<tr>
										<td className={'row-table td'}>
											<strong>Consultas online</strong> por R$ 40,00
											<button
												type='button'
												className='btn btn-secondary'
												data-toggle='tooltip'
												data-html='true'
												data-placement='top'
												title={
													'Consultas relacionadas ao coronavírus além de psicologia, psiquiatria e muitas outras especialidades. Todas consultas online de R$ 90 por R$ 40, ilimitadas e com retorno gratuito em até 30 dias.'
												}>
												<FaQuestion size={8} color={'#FFF'} />
											</button>
										</td>
										<td>
											<FaCheck size={20} color={'#23A455'} />
										</td>
										<td>
											<FaCheck size={20} color={'#23A455'} />
										</td>
										<td>
											<FaCheck size={20} color={'#23A455'} />
										</td>
									</tr>
									<tr className={'dif tr-border'}>
										<td className={'row-table td'} >

											<strong>Droga Raia</strong> e <strong> Drogasil</strong>{' '}
											com até 60% de desconto
											<button
												type='button'
												className='btn btn-secondary'
												data-toggle='tooltip'
												data-html='true'
												data-placement='top'
												title={
													'15% de descontos em medicamentos genéricos, tarjados e de marca, em toda rede Droga Raia e Drogasil'
												}>
												<FaQuestion size={8} color={'#FFF'} />
											</button>
										</td>
										<td>
											<FaCheck size={20} color={'#23A455'} />
										</td>
										<td></td>
										<td>
											<FaCheck size={20} color={'#23A455'} />
										</td>
									</tr>
									<tr>
										<td className={'row-table td'}>
											<strong>Consultas presenciais</strong> por R$ 40,00
											<button
												type='button'
												className='btn btn-secondary'
												data-toggle='tooltip'
												data-html='true'
												data-placement='top'
												title={
													'<strong>Genéricos</strong><br/>60% tarjado; 35% sem tarja. <br/><strong>Medicamentos de marca</strong><br/> 25% em tarjados; 10% sem tarja<br/><strong>Desconto em perfumaria</strong><br/> 5% em toda a loja'
												}>
												<FaQuestion size={8} color={'#FFF'} />
											</button>
										</td>
										<td></td>
										<td>
											<FaCheck size={20} color={'#23A455'} />
										</td>
										<td>
											<FaCheck size={20} color={'#23A455'} />
										</td>
									</tr>
									<tr className={'dif tr-border'}>
										<td className={'row-table td'}>
											<strong>Exames</strong> com 20% de desconto
											<button
												type='button'
												className='btn btn-secondary'
												data-toggle='tooltip'
												data-html='true'
												data-placement='top'
												title={
													'Mais de 3000 exames realizados nos próprios centros médicos do dr.consulta, incluindo ressonância magnética, tomografia, ultrassonografia, raio-x, dentre outros.'
												}>
												<FaQuestion size={8} color={'#FFF'} />
											</button>
										</td>
										<td></td>
										<td>
											<FaCheck size={20} color={'#23A455'} />
										</td>
										<td>
											<FaCheck size={20} color={'#23A455'} />
										</td>
									</tr>
									<tr>
										<td className={'row-table td'}>
											<strong>SmartFit</strong> por R$ 39,90/mês
											<button
												type='button'
												className='btn btn-secondary'
												data-toggle='tooltip'
												data-html='true'
												data-placement='top'
												title={
													'Plano nacional de R$ 99,90 por R$ 39,90/mes significando um desconto de R$60,00 todos os meses para uso da Smart Fit. Sem fidelidade de 12 meses, sem multa de cancelamento, sem taxa de manutenção e sem taxa de adesão.'
												}>
												<FaQuestion size={8} color={'#FFF'} />
											</button>
										</td>
										<td></td>
										<td></td>
										<td>
											<FaCheck size={20} color={'#23A455'} />
										</td>
									</tr>

									<tr className={loja}>
										<th className='noneOnMobile'></th>
										{tablePrice.map((tablePrice)=>{
											return(
												<th className={tablePrice.styleBot}>
													<h2>
														<strong
															className={`product-table-plan-price ${colCount}`}>
															R$ {tablePrice.price}
															<span className='price-span'>/mês</span>
														</strong>
													</h2>
													<Link
														to={tablePrice.link}>
														<button
															className={`btn-orange1 ${colCount}`}
															style={tablePrice.styleButton}>
															ASSINAR AGORA
														</button>
													</Link>
										</th>
											)})}
									</tr>
								</tbody>
							</table>
							{loja === 'brasiladmindividual' ? (
								<h3 className='table-carencia'>
									Carência de 30 dias corridos, para uso dos benefícios.
								</h3>
							) : (
								''
							)}
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
